// This code was taken from
// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
// and uses deprecated fallbacks if necessary since some browsers don't support copying to
// the clipboard from an unsecured HTTP connection. Which is a supported use case.
// It's not elegant, but it works.

const fallbackCopyTextToClipboard = (text) => {
  var textArea = document.createElement('textarea')
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    var successful = document.execCommand('copy')
    var msg = successful ? 'successful' : 'unsuccessful'
    console.log(`Fallback: Copying text command was ${msg}`)
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err)
  }

  document.body.removeChild(textArea)

  return successful
}

const copyTextToClipboard = (text) => {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text)
  }

  return navigator.clipboard.writeText(text).then(function() {
    console.log('Async: Copying to clipboard was successful!')

    return true
  }, function(err) {
    console.error('Async: Could not copy text: ', err)

    return false
  })
}

export {
  copyTextToClipboard
}
